import { SimpleAmount } from '@mews-commander/data-access';

export const isOverBudget = (remainingBudget: SimpleAmount) => remainingBudget.value < 0;
